import { getContrastColorFromRGBA } from "../helpers/contrastColor";

const vContrast = {
  inserted(el: HTMLElement) {
     if (el.classList.contains("main-border-color")) {
      return;
    }
    const bg = getComputedStyle(el).backgroundColor;
    const rgbArray = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);

    if (rgbArray != null && rgbArray.length >= 4) {
      const r = parseInt(rgbArray[1], 10);
      const g = parseInt(rgbArray[2], 10);
      const b = parseInt(rgbArray[3], 10);
      const a = rgbArray[4] !== undefined ? parseFloat(rgbArray[4]) : 1;
      
      const textColor = getContrastColorFromRGBA(r, g, b, a);
      el.style.color = textColor;

      const targets = el.querySelectorAll('p, span, strong, em, b, i, small, label');
      targets.forEach((child: Element) => {
        (child as HTMLElement).style.color = textColor;
      });

      // const svgs = el.querySelectorAll('svg');
      // svgs.forEach((svg: Element) => {
      //   console.log(rgbArray, textColor, svg);
      //   (svg as SVGElement).setAttribute('stroke', textColor);
      //   // (svg as SVGElement).setAttribute('fill', textColor);
      // });
    }
  },
};

export default vContrast;